export enum ModalType {
    Add,
    Edit,
    View,
    Url,
    Reject,
    Export
}